import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDataProvider } from 'react-admin'
import BaseOneEntityChart from './components/BaseOneEntityChart'

const useStyles = makeStyles(() => ({
  customCard: {
    marginBottom: '1rem',
  },
  section: {
    marginBottom: '1rem',
  },
}))

export const Dashboard = () => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const [UserProfilesTotal, setUserProfilesTotal] = useState(0)
  const [UserProfilesChartData, setUserProfilesChartData] = useState([])
  const [GroupsTotal, setGroupsTotal] = useState(0)
  const [GroupsChartData, setGroupsChartData] = useState([])
  const [QuestionsTotal, setQuestionsTotal] = useState(0)
  const [QuestionsChartData, setQuestionsChartData] = useState([])
  const [ChecklistsTotal, setChecklistsTotal] = useState(0)
  const [ChecklistsChartData, setChecklistsChartData] = useState([])
  const [UserExamsTotal, setUserExamsTotal] = useState(0)
  const [UserExamsChartData, setUserExamsChartData] = useState([])

  const fetchTotal = async (resource, setTotal) => {
    try {
      const { total } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'createdAt', order: 'DESC' },
        // UNDEFINED_VARIABLE,
      })
      setTotal(total)
    } catch (error) {
      console.error(`Error fetching total for ${resource}:`, error)
    }
  }

  const fetchChartData = async (resource, setChartData, label) => {
    try {
      const { data } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 0 },
        sort: { field: 'createdAt', order: 'ASC' },
        // UNDEFINED_VARIABLE,
      })

      let cumulativeTotal = 0
      const chartData = []
      const groupedData = {}

      data.forEach((item) => {
        const date = new Date(item.createdAt).toLocaleDateString('en-CA')
        groupedData[date] = (groupedData[date] || 0) + 1
      })

      for (const date in groupedData) {
        cumulativeTotal += groupedData[date]
        chartData.push({ date, [label]: cumulativeTotal })
      }

      setChartData(chartData)
    } catch (error) {
      console.error(`Error fetching chart data for ${resource}:`, error)
    }
  }

  useEffect(() => {
    fetchTotal('UserProfiles', setUserProfilesTotal)
    fetchChartData('UserProfiles', setUserProfilesChartData, 'UserProfiles')
    fetchTotal('Groups', setGroupsTotal)
    fetchChartData('Groups', setGroupsChartData, 'Groups')
    fetchTotal('Questions', setQuestionsTotal)
    fetchChartData('Questions', setQuestionsChartData, 'Questions')
    fetchTotal('Checklists', setChecklistsTotal)
    fetchChartData('Checklists', setChecklistsChartData, 'Checklists')
    fetchTotal('UserExams', setUserExamsTotal)
    fetchChartData('UserExams', setUserExamsChartData, 'UserExams')
  }, [dataProvider])

  return (
    <>
      <div className={classes.section}>
        <Card>
          <CardHeader title="Welcome to the administration" />
          <CardContent>
            Skipper exam prep and yacht theory learning with real-world charter readiness tools.
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader title={`UserProfiles Total: ${UserProfilesTotal}`} />
        <BaseOneEntityChart
          data={UserProfilesChartData}
          index="date"
          categories={['UserProfiles']}
          colors={['#3b82f6']}
        />
      </Card>
      <Card>
        <CardHeader title={`Groups Total: ${GroupsTotal}`} />
        <BaseOneEntityChart
          data={GroupsChartData}
          index="date"
          categories={['Groups']}
          colors={['#10b981']}
        />
      </Card>
      <Card>
        <CardHeader title={`Questions Total: ${QuestionsTotal}`} />
        <BaseOneEntityChart
          data={QuestionsChartData}
          index="date"
          categories={['Questions']}
          colors={['#607d8b']}
        />
      </Card>
      <Card>
        <CardHeader title={`Checklists Total: ${ChecklistsTotal}`} />
        <BaseOneEntityChart
          data={ChecklistsChartData}
          index="date"
          categories={['Checklists']}
          colors={['#4b88a2']}
        />
      </Card>
      <Card>
        <CardHeader title={`UserExams Total: ${UserExamsTotal}`} />
        <BaseOneEntityChart
          data={UserExamsChartData}
          index="date"
          categories={['UserExams']}
          colors={['#789f80']}
        />
      </Card>
    </>
  )
}
